import { render, staticRenderFns } from "./EmolumentoCadastro.vue?vue&type=template&id=688d0308&scoped=true&"
import script from "./EmolumentoCadastro.vue?vue&type=script&lang=js&"
export * from "./EmolumentoCadastro.vue?vue&type=script&lang=js&"
import style0 from "./EmolumentoCadastro.vue?vue&type=style&index=0&id=688d0308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d0308",
  null
  
)

export default component.exports